import './EventsItem.scss';
import React from 'react';
import { Card, Icon } from 'antd';
import Button from 'Components/Shared/Button/Button';
import DateSpan from 'Components/Shared/DateSpan/DateSpan';
import LocationSpan from 'Components/Shared/LocationSpan/LocationSpan';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
	event: Julius.Website.EventOverviewViewModel;
	isMobile: boolean;
	isBoxView: boolean;
	onClick: (eventID: number) => void;
}

const EventsItem: React.SFC<IProps> = ({
	event: {
		id,
		name,
		oneLiner,
		venue,
		city,
		imageSmallUrl,
		categoryName,
		subCategoryName,
		firstDate,
		lastDate,
		isMultipleVenues,
	},
	isMobile,
	isBoxView,
	onClick,
}) => {

	const Description = () => (
		<>
			<span className='category'>{ categoryName }</span>
			<span className='name'>{ name }</span>
			<span className='oneliner'>{ oneLiner }</span>
		</>
	);

	const DateAndLocation = () => (
		<table>
			<tbody>
				<tr className='date'>
					<td>
						<Icon type='calendar' />
					</td>
					<td>
						<DateSpan 
							firstDate={ firstDate } 
							lastDate={ lastDate } 
							dateFormat='short'
						/>
					</td>
				</tr>
				<tr className='location'>
					<td>
						<Icon type='environment-o' />
					</td>
					<td>
						<LocationSpan
							venue={ venue }
							city={ city }
							isMultipleVenues={ isMultipleVenues }
						/>
					</td>
				</tr>
			</tbody>
		</table>
	);

	const ButtonReadMore = () => (
		<div className='btn-read-more-container'>
			<Button color='red' boxShadow={ true }>
				<FormattedText
					displayName='Läs mer & boka'
					formattedName='events.showmoreandbook'
				/>
			</Button>
		</div>
	);

	if (isMobile || isBoxView) {
		const cardCover = (
			<img className='image' alt={ name } src={ imageSmallUrl } />
		);

		return (
			<div className='events-item box-view' onClick={ () => onClick(id) }>
				<Card cover={ cardCover } bordered={ false }>
					<Description />
					<DateAndLocation />
					<ButtonReadMore />
				</Card>
			</div>
		);
	}

	return (
		<div className='events-item list-view' onClick={ () => onClick(id) }>
			<div className='img-container'><img alt={ name } src={ imageSmallUrl } /></div>
			<div className='desc-container'><Description /></div>
			<div className='meta-container'><DateAndLocation /></div>
			<div className='btn-container'><ButtonReadMore /></div>
		</div>
	);
};

export default EventsItem;


// WEBPACK FOOTER //
// ./src/pages/EventsPage/EventsItem/EventsItem.tsx